<template>

  <div style="height: 100%;overflow: hidden;background:#f4f4f4">
    <van-tabs color="#D6BE93" v-model="state" @change="onChange">
      <van-tab :title="'待评论('+canComment+')'">
        <div class="coupon" v-if="canmyCommentsListUi.length > 0">
          <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">

            <goodscell class="goodsCell" :isShowBtn="false" :info="item" v-for="(item,index) in canmyCommentsListUi" :key="index">
              <div class="comments-btn" @click="navToEvaluate(item.id)">发布评价</div>
            </goodscell>

          </van-list>

        </div>
        <div v-else>
          <img width="100%" src="../../assets/index/no_data.png" alt="">
          <div class="no-data">暂无数据</div>
        </div>
      </van-tab>
      <van-tab :title="'已评价('+hasComment+')'">
        <div v-if="state == 1  && myCommentsListUi.length !=0">
          <van-list v-model="loadingH" :immediate-check="false" :finished="finishedH" finished-text="没有更多了" @load="onLoadH" :offset="1">
            <div class="has-comments" v-for="(item,index) in myCommentsListUi" :key="index">

              <div class="has-comments-top">
                <img class="user-tx" :src="item.comment.avatar" alt="">
                <div class="user-box">
                  <div class="user-name">{{item.comment.nickname}}</div>
                  <van-rate readonly v-model="item.comment.star" />
                </div>
                <div class="update-time">{{item.comment.updateTime}}</div>
              </div>
              <!-- <van-grid :column-num="3" :gutter="5">
                <img class="content-pic" v-for="(pic,idx) in item.comment.picUrls" :key="idx" :src="pic">

              </van-grid> -->
              <van-grid :column-num="4" :gutter="5">
                <van-grid-item v-for="(pic,idx) in item.comment.picUrls" :key="idx" @click="showImgs(item.comment.picUrls,idx)" :icon="pic" text="" />
              </van-grid>
              <div class="comment-content">
                {{item.comment.content}}
              </div>
              <goodscell class="goodsCell" :isShowBtn="false" :info="item" :key="index">
              </goodscell>
            </div>
          </van-list>

        </div>
        <div v-else>
          <img width="100%" src="../../assets/index/no_data.png" alt="">
          <div class="no-data">暂无数据</div>
        </div>

      </van-tab>
    </van-tabs>

  </div>
</template>


<script>
import { Dialog, ImagePreview } from "vant";

import { getUserCommentList } from "@/api/index";
import goodscell from "../../components/goodscell";

export default {
  components: { goodscell, ImagePreview },
  name: "mycoupon",
  data() {
    return {
      emptyimage: "https://img.yzcdn.cn/vant/coupon-empty.png",
      showcountNumber: false,
      showclosebutton: false,
      showList: true,
      chosenCoupon: -1,
      myCommentsListUi: [],
      canmyCommentsListUi: [],
      value: 4,
      canCoupondataInfo: {
        showType: 0,
        page: 1,
        size: 10,
      },
      coupondataInfo: {
        showType: 1,
        page: 1,
        size: 10,
      },
      code: "",
      state: 0,
      loading: false,
      finished: false,
      loadingH: false,
      finishedH: false,
      canComment: 0,
      hasComment: 0,
    };
  },

  mounted() {
    console.log(sessionStorage.getItem("hasEvaluate"));
    if (sessionStorage.getItem("hasEvaluate")) {
      this.state = 1;
    }
    // if (sessionStorage.getItem("hasEvaluate")) {
    //   this.state = 1;
    this.canCoupondataInfo = {
      showType: 0,
      page: 1,
      size: 10,
    };
    this.getCanMyComments(this.canCoupondataInfo);

    //   sessionStorage.removeItem("hasEvaluate");
    // } else {
    this.coupondataInfo = {
      showType: 1,
      page: 1,
      size: 10,
    };
    this.getMyComments(this.coupondataInfo);
    // }
  },
  methods: {
    showImgs(list, idx) {
      ImagePreview({
        images: list,
        startPosition: idx,
        onClose() {
          // do something
        },
      });
    },
    navToEvaluate(id) {
      this.$router.push({
        path: "/evaluate",
        query: {
          orderGoodsId: id,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const nextPaging = {
          showType: this.coupondataInfo.showType,
          page: this.coupondataInfo.page + 1,
          size: 10,
        };
        this.coupondataInfo = nextPaging;
        this.getMyComments(this.coupondataInfo);
      }, 500);
    },
    onLoadH() {
      // 异步更新数据
      setTimeout(() => {
        const nextPaging = {
          showType: this.coupondataInfo.showType,
          page: this.coupondataInfo.page + 1,
          size: 10,
        };
        this.coupondataInfo = nextPaging;
        this.getMyComments(this.coupondataInfo);
      }, 500);
    },
    getCanMyComments(data) {
      getUserCommentList(data).then((res) => {
        if (res.data.errno == 0) {
          console.log(res.data.data);
          if (res.data.data.count == 0) return;

          this.canmyCommentsListUi = this.canmyCommentsListUi.concat(
            res.data.data.list
          );
          this.canComment = res.data.data.count;
          sessionStorage.removeItem("hasEvaluate");
          this.loading = false;
          console.log(this.canmyCommentsListUi);
          // // 数据全部加载完成
          if (this.canmyCommentsListUi.length == res.data.data.count) {
            this.finished = true;
          }
        } else if (res.data.errno == 501) {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          }).then(() => {
            // on close
            this.$router.push("/login");
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    getMyComments(data) {
      getUserCommentList(data).then((res) => {
        if (res.data.errno == 0) {
          if (res.data.data.count == 0) return;

          console.log(res.data.data.list);

          this.myCommentsListUi = this.myCommentsListUi.concat(
            res.data.data.list
          );
          this.hasComment = res.data.data.count;
          this.loadingH = false;
          // // 数据全部加载完成
          if (this.myCommentsListUi.length == res.data.data.count) {
            this.finishedH = true;
          }
          sessionStorage.removeItem("hasEvaluate");
        } else if (res.data.errno == 501) {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          }).then(() => {
            // on close
            this.$router.push("/login");
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    onChange(index) {
      this.loading = false;
      this.finished = false;
      this.loadingH = false;
      this.finishedH = false;
      console.log(index);
      if (index == 0) {
        this.canmyCommentsListUi = [];
        this.canCoupondataInfo.page = 1;
        this.canCoupondataInfo.showType = index;
        this.getCanMyComments(this.canCoupondataInfo);
      } else {
        this.myCommentsListUi = [];
        this.coupondataInfo.page = 1;
        this.coupondataInfo.showType = index;
        this.getMyComments(this.coupondataInfo);
      }
    },
  },
};
</script>


<style scoped lang="scss">
.has-comments {
  padding: 0 1.5rem 1.5rem;
  background: #fff;
  margin: 1.3rem 0 0;
  .has-comments-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 7.6rem;
    .user-tx {
      height: 3.2rem;
      width: 3.2rem;
      border-radius: 100%;
    }
    .user-box {
      flex: 1;
      text-align: left;
      margin-left: 1rem;
      .user-name {
        font-family: PingFangSC-Semibold;
        font-size: 1.4rem;
        color: #424242;
        line-height: 1.4rem;
        font-weight: 600;
        line-height: 1.8rem;
      }
    }

    .update-time {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      text-align: right;
      line-height: 1.2rem;
    }
  }
  .content-pic {
    width: 30%;
    height: auto;
    margin-right: 0.5rem;
  }
  .comment-content {
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    text-align: justify;
    line-height: 1.8rem;
    margin: 1.5rem 0 1rem;
  }
  .goodsCell {
    width: 100%;
    padding: 1.6rem 1.2rem;
    background: #fafafa;
    border-radius: 8px;
    margin-bottom: 0;
    /deep/ .van-card {
      background: #fafafa;
    }
    /deep/ .van-image__img {
      border-radius: 5px;
    }
  }
}
/deep/ .van-coupon__description {
  text-align: left;
  margin: 0;
}
.coupon {
  height: 100%;
  overflow-y: scroll;
  padding: 1rem 0.5rem 4rem;
  box-sizing: border-box;
}
.duihuan-box {
  display: flex;
  justify-content: space-between;
  .code-input {
    flex: 1;
    height: 3.6rem;
    line-height: 3.6rem;
    box-sizing: border-box;
    padding: 0 3rem;
    border: 1px solid rgba(66, 66, 66, 0.1);
    border-radius: 8px;
  }
  .duihuan {
    background: #e5e5e5;
    border: 1px solid rgba(66, 66, 66, 0.1);
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-size: 1.6rem;
    color: #424242;
    letter-spacing: 0;
    text-align: center;
    line-height: 3.6rem;
    width: 6.6rem;
    height: 3.6rem;
    text-align: center;
    margin-left: 1rem;
    box-sizing: border-box;
  }
}
.goodsCell {
  padding: 1rem;
  width: 100%;
  .comments-btn {
    padding: 0.9rem 1.6rem;
    border: 1px solid #d9d9d9;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #787878;
    letter-spacing: 0;
    text-align: center;
    line-height: 1.4rem;
    border-radius: 16px;
    display: inline-block;
    float: right;
  }
}
/deep/ .van-tabs,
.van-tabs__content {
  height: 100%;
}
/deep/ .van-tabs__content {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 10rem;
  box-sizing: border-box;
}
/deep/ .product-list .product-item .select-guige {
  background: #f2f2f2 !important;
  color: #6f6f6f !important;
}
.no-data {
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #424242;
  letter-spacing: 0;
  line-height: 1.6rem;
}
/deep/ .van-grid-item__content--center {
  padding: 0;
  height: 8rem;
  overflow: hidden;
}
/deep/ .van-icon__image {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/person/myComments.vue